import { ArchiveList, ArchiveSearch } from "src/components";

export const Archive: React.FC = () => {
    return (
        <div className="archive-page app-theme2">
            <div className="container">
                <div className="row">
                <div className="col-12 col-lg-8 col-md-12 offset-lg-2 my-3" style={{ padding: 10 }}>
                        <div className="component-archive">
                            <ArchiveSearch />
                            <ArchiveList />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};